import { render, staticRenderFns } from "./powerdatas.vue?vue&type=template&id=3d555d7e&scoped=true"
import script from "./powerdatas.vue?vue&type=script&lang=js"
export * from "./powerdatas.vue?vue&type=script&lang=js"
import style0 from "./powerdatas.vue?vue&type=style&index=0&id=3d555d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d555d7e",
  null
  
)

export default component.exports